import React, { useEffect, useState } from 'react';
import './../App.css';
import { auth, db } from '../firebase';
import { addDoc, collection, doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import Swal from 'sweetalert2';

function Plandetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [key, setkey] = useState("");
    const [status, setStatus] = useState("");
    const [amount, setamount] = useState(13999);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                await loadUserData(user.uid);
            }
        });

        return () => unsubscribe();
    }, []);

    const loadUserData = async (uid) => {
        try {
            const docRef = doc(db, 'users', uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                setStatus(data.status || "");
                setamount(data.amount || "");

            } else {
                Toast.fire({ icon: "error", title: "User data not found!" });
            }

            const docRef1 = doc(db, 'keys', 'aibWQsfB7aD8JGkIT6Oc');
            const docSnap1 = await getDoc(docRef1);

            if (docSnap1.exists()) {
                const data = docSnap1.data();
                setkey(data.key || "");

            } else {
                Toast.fire({ icon: "error", title: "User data not found!" });
            }
        } catch (error) {
            console.error(error);
            Toast.fire({ icon: "error", title: "Failed to fetch user data" });
        }
    };



    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const initiatePayment = async (plan, amount) => {
        const userId = auth.currentUser?.uid;
        const email = auth.currentUser?.email;

        const docRef = doc(db, 'users', userId);
        const docSnap = await getDoc(docRef);
        const data = docSnap.data();

        const res = await loadRazorpayScript();
        if (!res) {
            alert("Failed to load Razorpay SDK");
            return;
        }

        const options = {
            key: key,
            amount: amount * 100,
            currency: "INR",
            name: data.hotelname,
            description: plan,
            handler: async function (response) {
                Toast.fire({
                    icon: "success",
                    title: `Payment successful! Payment ID: ${response.razorpay_payment_id}`
                });


                const today = new Date();
                let newEndDate = new Date(today);

                if (data.endDate) {
                    const currentEnd = new Date(data.endDate);
                    if (currentEnd > today) {
                        newEndDate = new Date(currentEnd);
                    }
                }

                if (plan === 'Monthly Plan') {
                    newEndDate.setDate(newEndDate.getDate() + 30);
                } else {
                    newEndDate.setDate(newEndDate.getDate() + 365);
                }

                const formattedEndDate = formatDate(newEndDate);
                const formattedToday = formatDate(today);

                await updateDoc(docRef, {
                    endDate: formattedEndDate,
                    currentActiveDate: formattedToday,
                    transid: response.razorpay_payment_id,
                    amount: amount,
                    status: "Active"
                });

                await addDoc(collection(db, "payments"), {
                    userId,
                    email,
                    hotelname: data.hotelname,
                    plan,
                    amount,
                    paymentId: response.razorpay_payment_id,
                    paymentDate: serverTimestamp(),
                    endDate: formattedEndDate
                });

                window.location.href = "/home";
            },
            prefill: {
                name: data.hotelname || "Activation Payment",
                email: email || "blueviperstechnology@gmail.com",
                contact: data.mobile || "8459432930"
            },
            theme: {
                color: "#528FF0"
            }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };

    function formatDate(date) {
        return date.toISOString().split('T')[0];
    }

    return (
        <div className="plans-container">
            <h4 className='plans-title '>Choose Plan</h4><hr />
            {
                status === 'Demo' ?
                    <div className="plans-grid">
                        <div className="plan-card  plan-highlight">
                            <h3>Activation Fee</h3>

                            <p className="plan-price">₹{amount}.00<span>/month</span></p>

                            <ul className="plan-features">
                                <li>✓ Access to all modules</li>
                                <li>✓ 24/7 Support</li>
                                <li>✓ Regular Updates</li>
                            </ul>
                            <button onClick={() => initiatePayment('Activation Fee', { amount })} className="select-button">Select Plan</button>
                        </div>

                        <div className="plan-card ">
                            <div className="support-section">
                                <h4>💬 Need Help?</h4>
                                <br />
                                <p><span className="icon">👨‍💼</span>Contact: <strong>Rohan Thorat</strong></p>
                                <p><span className="icon">📞</span>Phone: <a href="tel:8459432930">8459432930</a></p>
                                <p>
                                    <a href="https://wa.me/918459432930" target="_blank" rel="noopener noreferrer">
                                        💬 Chat on WhatsApp
                                    </a>
                                </p>
                                <br /><br />
                                <a href="tel:8459432930" className="select-button" style={{ color: "white" }}>📞 Call Now</a>
                            </div>
                        </div>
                    </div> :
                    <div className="plans-grid">
                        <div className="plan-card  plan-highlight">
                            <h3>Monthly Plan</h3>
                            <p className="plan-price">₹599.00<span>/month</span></p>
                            <ul className="plan-features">
                                <li>✓ Access to all modules</li>
                                <li>✓ 24/7 Support</li>
                                <li>✓ Regular Updates</li>
                            </ul>
                            <button onClick={() => initiatePayment('Monthly Plan', 599)} className="select-button">Select Plan</button>
                        </div>

                        <div className="plan-card ">
                            <div className="support-section">
                                <h4>💬 Need Help?</h4>
                                <br />
                                <p><span className="icon">👨‍💼</span>Contact: <strong>Rohan Thorat</strong></p>
                                <p><span className="icon">📞</span>Phone: <a href="tel:8459432930">8459432930</a></p>
                                <p>
                                    <a href="https://wa.me/918459432930" target="_blank" rel="noopener noreferrer">
                                        💬 Chat on WhatsApp
                                    </a>
                                </p>
                                <br /><br />
                                <a href="tel:8459432930" className="select-button" style={{ color: "white" }}>📞 Call Now</a>
                            </div>
                        </div>

                        <div className="plan-card plan-highlight">
                            <h3>Yearly Plan</h3>
                            <p className="plan-price">₹4,499.00<span>/year</span></p>
                            <ul className="plan-features">
                                <li>✓ Access to all modules</li>
                                <li>✓ 24/7 Support</li>
                                <li>✓ Regular Updates</li>
                            </ul>
                            <button onClick={() => initiatePayment('Yearly Plan', 5499)} className="select-button">Select Plan</button>
                        </div>
                    </div>

            }




        </div >
    );
}

export default Plandetails;
